exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "tr[data-v-0178a11d]{cursor:pointer;text-align:left;white-space:pre-wrap}tr[data-v-0178a11d]:nth-child(odd){background-color:#f2f2f2;color:#000}tr[data-v-0178a11d]:hover{background-color:#cde9ef;cursor:pointer}td[data-v-0178a11d]{min-width:10px;padding:5px;margin:0;border:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0178a11d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/wervendetail.vue
// module id = 23
// module chunks = 3